import { atom } from 'jotai';
import type { SurchargeConfig } from '../type/types';

/**
 * Atom for managing setup intent popup open state
 */
export const setupIntentPopupOpenAtom = atom<boolean>(false);

/**
 * Atom for storing the current customer ID for setup intent
 */
export const setupIntentPopupCustomerIdAtom = atom<number>(0);

/**
 * Atom for storing the Stripe account for setup intent
 */
export const setupIntentPopupStripeAccountAtom = atom<string | null>(null);

/**
 * Atom for storing payment data for setup intent (amount and currency)
 */
export const setupIntentPopupPaymentDataAtom = atom<{
    currency: string;
    amount: number; // without surcharge
    amountWithSurcharge: number; // with surcharge
    surchargeConfig: SurchargeConfig;
} | null>(null);

/**
 * Atom for storing the invoice payment ID for setup intent
 */
export const setupIntentPopupInvoicePaymentIdAtom = atom<string | null>(null);

/** Proposal URL segment used for sync confirm after setup intent succeeds */
export const setupIntentPopupUrlSegmentAtom = atom<string>('');

/**
 * Atom for storing the Stripe publishable key for setup intent.
 * This allows the popup to use the correct publishable key for
 * the invoice's Stripe account configuration.
 */
export const setupIntentPopupPublishableKeyAtom = atom<string | null>(null);
